
import React from 'react';
import {Route, Routes} from 'react-router-dom'
import USMComponent from './Components/Apps/USMComponent'
import PicHaxxComponent from './Components/Apps/PicHaxxComponent';
import SteelHaxComponent from './Components/Apps/SteelHaxComponent';
import BannerBomb3GenericTWNComponent from './Components/Apps/BannerBomb3GenericTWNComponent';
import BannerBomb3GenericComponent from './Components/Apps/BannerBomb3GenericComponent';
import BannerBomb3CustomComponent from './Components/Apps/BannerBomb3CustomComponent';
import ThreeDSCustomSaveComponent from './Components/Apps/3DSCustomSaveComponent';
import AboutMeComponent from './Components/AboutMeComponent';
export default function App(props) {
  let download=function(fName,datablob) {
    let a = window.document.createElement('a');
    a.href = window.URL.createObjectURL(new Blob([datablob], { type: 'application/octet-stream' }));
    a.download = fName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  return (
    <Routes>
      <Route path="/" element={
        <AboutMeComponent />
        } />
      <Route path="/usm" element={<USMComponent onDownload={download}/>}/>
      <Route path="/bb3custom" element={<BannerBomb3CustomComponent onDownload={download}/>}/>
      <Route path="/bb3gen" element={<BannerBomb3GenericComponent onDownload={download}/>}/>
      <Route path="/bb3gentwn" element={<BannerBomb3GenericTWNComponent onDownload={download}/>}/>
      <Route path="/pichaxx" element={<PicHaxxComponent onDownload={download}/>}/>
      <Route path="/steelhax" element={<SteelHaxComponent onDownload={download}/>}/>
      <Route path="/sav" element={<ThreeDSCustomSaveComponent onDownload={download}/>}/>
    </Routes>
  );  

}